import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Paper, useTheme} from '@material-ui/core';
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiPaper-elevation1': {
            boxShadow: 'none !important;'
        }
    },
    section: {
        marginBottom: theme.spacing(1),
        padding: theme.spacing(2)
    },
    nextBillingDate: {
        marginTop: theme.spacing(2)
    },
    paymentMethod: {
        display: 'flex',
        alignItems: 'center',
    },
    creditBalance: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    autoRecharge: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '200px'
    },
    planSectionFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    }
}));

const SubscriptionSkeletonLoader = () => {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <div className={classes.root}>
            <Paper className={classes.section}>
                <div className={classes.planSectionFlex}>
                    <div>
                        <Skeleton variant="text" width={150} height={30} />
                        <Skeleton variant="text" width={100} height={20} />
                    </div>
                    <Skeleton variant="text" width={200} height={50} />
                </div>
                <Skeleton variant="text" width={150} height={20} className={classes.nextBillingDate}/>
            </Paper>

            <Paper className={classes.section}>
                <Skeleton variant="text" width={150} height={30} />
                <div className={classes.paymentMethod}>
                    <Skeleton variant="text" width={100} height={20} style={{ marginRight: theme.spacing(1) }} />
                    <Skeleton variant="text" width={100} height={20} style={{ marginRight: theme.spacing(1) }} />
                    <Skeleton variant="text" width={80} height={20} />
                </div>
            </Paper>

            <Paper className={classes.section}>
                <Skeleton variant="text" width={150} height={30} />
                <div className={classes.creditBalance}>
                    <Skeleton variant="text" width={100} height={40} />
                    <Skeleton variant="rect" width={120} height={36} style={{ borderRadius: 4 }} />
                </div>
                <Skeleton variant="text" width={80} height={20} />
            </Paper>

            <Paper className={classes.section}>
                <Skeleton variant="text" width={150} height={30} />
                <div className={classes.autoRecharge}>
                    <div>
                        <Skeleton variant="text" width={100} height={20} style={{ marginRight: theme.spacing(2) }} />
                        <Skeleton variant="rect" width={100} height={36} style={{ display: 'inline-block', marginRight: theme.spacing(2) }} />
                        <Skeleton variant="rect" width={100} height={36} style={{ display: 'inline-block' }} />
                    </div>
                    <Skeleton variant="rect" width={40} height={20} style={{ borderRadius: 12 }} />
                </div>
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="text" width="90%" height={20} />
            </Paper>
        </div>
    );
};

export default SubscriptionSkeletonLoader;